export const LifeEmpty = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.33205C2 15.1664 12 21 12 21C12 21 22 15.1664 22 8.33205C22 5.44058 19.9184 3.60056 17.1575 3.07484C14.3965 2.54912 12 4.9655 12 4.9655C12 4.9655 9.60352 2.54912 6.84254 3.07484C4.08155 3.60056 2 5.44058 2 8.33205Z"
        fill="#E8ECF8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 4.9655C12 4.9655 9.60352 2.54912 6.84254 3.07484C4.08155 3.60056 2 5.44058 2 8.33205C2 15.1664 12 21 12 21C12 21 22 15.1664 22 8.33205C22 5.44058 19.9184 3.60056 17.1575 3.07484C14.3965 2.54912 12 4.9655 12 4.9655ZM12 19.8242C12.2542 19.6617 12.593 19.4386 12.9905 19.1614C13.9023 18.5257 15.1138 17.6116 16.3209 16.4948C18.795 14.2061 21 11.2961 21 8.33205C21 6.05505 19.4054 4.52083 16.9704 4.05719C15.922 3.85756 14.8841 4.20971 14.0387 4.69174C13.6254 4.92736 13.2853 5.17895 13.0494 5.37124C12.9322 5.46684 12.8425 5.5463 12.7843 5.59967C12.7552 5.62631 12.6943 5.68507 12.7079 5.67176L12 6.3856L11.2784 5.65845C11.2908 5.67052 11.2448 5.62631 11.2157 5.59967C11.1575 5.5463 11.0678 5.46684 10.9506 5.37124C10.7147 5.17895 10.3746 4.92736 9.96132 4.69174C9.11591 4.20971 8.078 3.85756 7.02959 4.05719C4.59463 4.52083 3 6.05505 3 8.33205C3 11.2961 5.205 14.2061 7.67907 16.4948C8.88623 17.6116 10.0977 18.5257 11.0095 19.1614C11.407 19.4386 11.7458 19.6617 12 19.8242Z"
        fill="#959CC0"
      />
      <ellipse
        cx="7.28008"
        cy="8.50093"
        rx="3.09359"
        ry="3.54328"
        transform="rotate(34.6532 7.28008 8.50093)"
        fill="white"
        fill-opacity="0.4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.35088 7.22392L7.35272 7.22311L7.35487 7.22215L7.35812 7.22067L7.36056 7.21953C7.3576 7.22088 7.35386 7.22261 7.35088 7.22392ZM6.74555 5.85149C7.12461 5.68451 7.56727 5.85645 7.73424 6.23552C7.8998 6.61136 7.73291 7.04935 7.36056 7.21953L7.35012 7.22483C7.33668 7.23185 7.31091 7.24592 7.27543 7.26801C7.20436 7.31225 7.09533 7.38803 6.96861 7.50296C6.71722 7.73098 6.39069 8.1178 6.15136 8.73395C6.00138 9.12006 5.5668 9.31149 5.18069 9.16152C4.79458 9.01154 4.60316 8.57696 4.75313 8.19085C5.08629 7.33314 5.55758 6.75769 5.96088 6.3919C6.16151 6.20992 6.34405 6.08091 6.48271 5.99459C6.55209 5.9514 6.61073 5.91875 6.65548 5.89537C6.67787 5.88367 6.69682 5.87427 6.71194 5.86702L6.73174 5.85771L6.73941 5.85422L6.74267 5.85276L6.74416 5.8521L6.74555 5.85149Z"
        fill="white"
      />
      <path
        d="M11.5 18C11.5 18 6.5 15.5 3.5 11C4.5 15.5 12 20.5 12 20.5C12 20.5 17.9249 16.4423 19.6862 13.1365C21.3583 9.99836 22 6.5 19.5 5C19.5 5 20 6.5 18.5 10C17 13.5 11.5 18 11.5 18Z"
        fill="#959CC0"
        fill-opacity="0.3"
      />
      <circle cx="11.5" cy="16.5" r="0.5" fill="#BAC2E0" />
      <circle cx="14.5" cy="13.5" r="0.5" fill="#BAC2E0" />
      <circle cx="16.5" cy="12.5" r="0.5" fill="#BAC2E0" />
      <circle cx="14" cy="16" r="1" fill="#BAC2E0" />
      <circle cx="18" cy="10" r="1" fill="#BAC2E0" />
    </svg>
  );
};
